var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 36,
    viewBox: "0 0 20 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1917 31.4526C19.661 31.9669 19.9218 32.6436 19.8957 33.3474C19.8957 34.0511 19.6349 34.7008 19.1395 35.215C18.6701 35.7023 18.0183 36 17.3403 36C16.6623 36 16.0104 35.7564 15.515 35.2692L0.756193 19.9489C0.521512 19.7053 0.338983 19.4075 0.208605 19.0827C0.0782268 18.7579 0 18.406 0 18.0541C0 17.7023 0.0782268 17.3504 0.208605 16.9985C0.338983 16.6737 0.521512 16.3759 0.756193 16.1323L15.515 0.81203C15.7497 0.568421 16.0365 0.35188 16.3494 0.216541C16.6884 0.081203 17.0274 0 17.3664 0C17.7053 0 18.0704 0.0541353 18.3833 0.189474C18.6962 0.324812 18.9831 0.541353 19.2438 0.784962C19.4785 1.02857 19.661 1.35338 19.7914 1.6782C19.9478 2.00301 20 2.35489 20 2.73383C20 3.08571 19.9218 3.43759 19.7914 3.76241C19.661 4.08722 19.4524 4.38496 19.1917 4.65564L6.28422 18.0541L8.73533 20.5714L19.1917 31.4526Z",
    fill: "#181725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.53da1387eea4e1c5ffbfeac90112742f.svg";
export { ForwardRef as ReactComponent };